'use client';

import {
  FileChartColumn,
  GitBranch,
  Shapes,
  ShieldCheck,
  Zap,
  ReceiptText,
} from 'lucide-react';

export default function FeaturesSection() {
  const features = [
    {
      icon: FileChartColumn,
      title: 'Reports for filing & audits',
      description:
        'Insightful, up-to-date payroll reports ready when regulators ask.',
    },
    {
      icon: GitBranch,
      title: 'Automatic salary proration',
      description:
        'Mid-cycle joiners, exits and changes handled without a single spreadsheet.',
    },
    {
      icon: Shapes,
      title: 'Custom salary components',
      description:
        'Templates for every employee type contractors, execs, hourly, salaried.',
    },
    {
      icon: ShieldCheck,
      title: 'Approval workflows',
      description:
        'Built-in role-based sign-off before any run is disbursed.',
    },
    {
      icon: Zap,
      title: 'Scheduled payroll runs',
      description:
        'Set your pay schedule once. Salaries generate automatically each cycle.',
    },
    {
      icon: ReceiptText,
      title: 'Digital payslips',
      description:
        'Delivered straight to employees, no HR chasing or PDF wrangling.',
    },
  ];

  return (
    <section id="features" className="features-section">
      <div className="features-container">
        <div className="features-header">
          <p className="features-label">FEATURES</p>
          <h2 className="features-title">
            Everything payroll needs, <span>minus the manual work.</span>
          </h2>
          <p className="features-subtitle">
            Avetium automates the repetitive, error-prone parts of paying
            <br className="desktop-break" />
            people — so HR and finance spend more time on the business.
          </p>
        </div>

        <div className="features-grid">
          {features.map((feature) => {
            const Icon = feature.icon;
            return (
              <div className="feature-wrapper" key={feature.title}>
                <div className="feature-card">
                  <div className="feature-icon">
                    <Icon size={25} strokeWidth={2} />
                  </div>
                  <div className="feature-content">
                    <h3>{feature.title}</h3>
                    <p>{feature.description}</p>
                  </div>
                </div>
                <div className="feature-dot" />
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}